import { render, staticRenderFns } from "./BranchEditor.vue?vue&type=template&id=433d083f&scoped=true&"
import script from "./BranchEditor.vue?vue&type=script&lang=ts&"
export * from "./BranchEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433d083f",
  null
  
)

export default component.exports